export default __webpack_public_path__ + "static/media/logo-package-tts-en.99eab685.png";